{
  "login": {
    "genericError": "Se produjo un error al iniciar sesión. Por favor, inténtalo de nuevo."
  },
  "acceptTerms": {
    "pleaseAccept": "Acepta los Términos y condiciones para continuar",
    "accepted": "Términos y condiciones aceptados",
    "failedGeneric": "No se pudieron aceptar los términos. Por favor, inténtalo de nuevo."
  },
  "discord": {
    "linkSuccess": "¡Cuenta de Discord vinculada! Por favor, verifica tus DMs a continuación.",
    "linkFailed": "No se pudo vincular la cuenta de Discord: {{message}}",
    "verificationSent": "¡Código de verificación enviado a tus DMs de Discord!",
    "dmVerified": "¡DMs de Discord verificados correctamente! Las notificaciones ya están disponibles.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "¡Cuenta de Discord desvinculada correctamente!",
    "userIdNotFound": "ID de usuario no encontrado. Por favor, inicia sesión de nuevo.",
    "clientIdNotConfigured": "ID de cliente de Discord no configurado. Comprueba tus variables de entorno.",
    "redirectUriNotConfigured": "URL de redirección no configurada correctamente. Comprueba tus variables de entorno.",
    "allowPopups": "Por favor, permite ventanas emergentes en este sitio para vincular tu cuenta de Discord",
    "linkFirst": "Por favor, vincula primero tu cuenta de Discord",
    "sendCodeFailed": "Error al enviar el código de verificación. Asegúrate de que el bot puede enviarte DMs.",
    "sendCodeFailedGeneric": "Error al enviar el código de verificación",
    "enterCode": "Por favor, introduce el código de verificación",
    "verifyCodeFailed": "Error al verificar el código. Por favor, inténtalo de nuevo.",
    "verifyFirst": "Por favor, verifica primero tus DMs de Discord",
    "updateSettingFailed": "Error al actualizar la configuración de notificaciones",
    "unlinkFailed": "Error al desvincular la cuenta de Discord",
    "categoryUpdated": "Categoría actualizada",
    "categoryUpdateFailed": "No se pudo actualizar la categoría",
    "categoryDeleted": "Categoría eliminada",
    "categoryDeleteFailed": "No se pudo eliminar la categoría",
    "defaultCategoryUpdated": "Categoría predeterminada actualizada",
    "setDefaultFailed": "No se pudo establecer la categoría predeterminada",
    "categoryCreated": "Categoría creada",
    "categoryCreateFailed": "No se pudo crear la categoría"
  },
  "subscription": {
    "failedLoadPricing": "No se pudo cargar la información de precios",
    "failedCheckout": "No se pudo iniciar el pago",
    "failedChangeSubscription": "No se pudo cambiar la suscripción",
    "failedOpenBillingPortal": "No se pudo abrir el portal de facturación",
    "cancelSuccess": "Tu suscripción ha sido cancelada correctamente",
    "cancelFailed": "No se pudo cancelar la suscripción",
    "resumeSuccess": "Tu suscripción ha sido reanudada correctamente",
    "resumeFailed": "No se pudo reanudar la suscripción",
    "updateSuccess": "¡Tu suscripción ha sido actualizada!",
    "newSubscriptionSuccess": "¡Bienvenido! Tu suscripción ya está activa."
  },
  "trial": {
    "activated": "¡Prueba activada! Disfruta de 7 días de FlippingPal.",
    "activationFailed": "No se pudo activar la prueba"
  },
  "account": {
    "emailBothFieldsRequired": "Por favor rellena ambos campos",
    "emailInvalid": "Por favor introduce una dirección de correo válida",
    "emailUpdated": "¡Correo actualizado! Revisa tu nuevo correo para confirmar. Cerrando sesión...",
    "emailFailed": "No se pudo cambiar el correo",
    "passwordAllFieldsRequired": "Por favor rellena todos los campos de contraseña",
    "passwordTooShort": "La nueva contraseña debe tener al menos 4 caracteres",
    "passwordsDoNotMatch": "Las nuevas contraseñas no coinciden",
    "passwordChanged": "¡Contraseña cambiada correctamente!",
    "passwordFailed": "No se pudo cambiar la contraseña",
    "closeAccountPasswordRequired": "Por favor introduce tu contraseña",
    "closeAccountConfirmRequired": "Por favor escribe \"CERRAR MI CUENTA\" para confirmar",
    "accountClosed": "Cuenta cerrada. Cerrando sesión...",
    "closeAccountFailed": "No se pudo cerrar la cuenta"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Por favor introduce al menos un ilvl mínimo o máximo",
    "ilvlValidMin": "Por favor introduce un ilvl mínimo válido",
    "ilvlValidMax": "Por favor introduce un ilvl máximo válido",
    "ilvlMinExceedsMax": "El ilvl mínimo no puede superar {{max}}",
    "ilvlMaxExceedsMax": "El ilvl máximo no puede superar {{max}}",
    "ilvlMinGreaterThanMax": "El ilvl mínimo no puede ser mayor que el ilvl máximo",
    "ilvlValidPrice": "Por favor introduce un precio válido (ej. 100g, 50g 30s, o 100)",
    "reqLvlMinRange": "El nivel mínimo requerido debe estar entre {{min}} y {{max}}",
    "reqLvlMaxRange": "El nivel máximo requerido debe estar entre {{min}} y {{max}}",
    "reqLvlMinGreaterThanMax": "El nivel mínimo requerido no puede ser mayor que el nivel máximo requerido",
    "ilvlAdded": "Snipe ilvl añadido",
    "ilvlUpdated": "Snipe ilvl actualizado",
    "ilvlSaveFailed": "No se pudo guardar el snipe ilvl",
    "ilvlRemoved": "Snipe ilvl eliminado",
    "ilvlRemoveFailed": "No se pudo eliminar el snipe ilvl",
    "selectItem": "Por favor selecciona un objeto",
    "validPetId": "Por favor introduce un ID de mascota válido o busca una mascota",
    "invalidPrice": "Por favor introduce un precio válido (ej. 100g, 50g 30s, o 100)",
    "itemAdded": "Snipe {{label}} añadido",
    "itemUpdated": "Snipe {{label}} actualizado",
    "itemAddFailed": "No se pudo añadir el snipe {{type}}",
    "itemRemoved": "Snipe {{type}} eliminado",
    "itemRemoveFailed": "No se pudo eliminar el snipe {{type}}",
    "editingWoWToken": "Editando alerta de snipe WoW Token",
    "editingSnipeAlert": "Editando alerta de snipe para {{name}}",
    "itemNotFound": "{{label}} no encontrado.",
    "importInvalidArrayFormat": "Formato no válido. Se esperaba un array de reglas snipe ilvl.",
    "importNoValidEntries": "No se encontraron entradas válidas. Los elementos del array necesitan los campos \"{{idKey}}\" y \"price\".",
    "importInvalidJsonFormat": "Formato JSON no válido. Se esperaba { {{idKey}}: goldPrice, ... } o un array de objetos.",
    "importSuccess": "Importación: {{added}} añadido(s), {{updated}} actualizado(s), {{skipped}} omitido(s)",
    "importIlvlSuccess": "{{count}} regla(s) snipe ilvl importada(s)",
    "importParseFailed": "No se pudo analizar o importar el JSON",
    "noItemsToExport": "No hay {{type}} para exportar",
    "noIlvlItemsToExport": "No hay objetos ilvl para exportar",
    "exportSuccess": "{{count}} {{type}} exportado(s)",
    "exportIlvlSuccess": "{{count}} objeto(s) ilvl exportado(s)",
    "enabledToggle": "Alertas de snipe {{state}}",
    "enabledToggleFailed": "No se pudo actualizar la configuración de snipe",
    "alertStyleUpdated": "Estilo de alerta establecido en {{style}}",
    "alertStyleFailed": "No se pudo actualizar el estilo de alerta",
    "realmsSaved": "Reinos de snipe guardados",
    "realmsSaveFailed": "No se pudieron guardar los reinos de snipe",
    "clearAllConfirm": "¿Estás seguro de que quieres eliminar todos los snipes {{label}}?",
    "clearAllSuccess": "Todos los snipes {{label}} eliminados",
    "clearAllFailed": "No se pudieron eliminar los snipes {{label}}",
    "cooldownCyclesUpdated": "Tiempo de espera establecido en {{cycles}} ciclo(s) omitido(s)",
    "cooldownCyclesFailed": "Error al actualizar el tiempo de espera",
    "cooldownCyclesInvalid": "El tiempo de espera debe estar entre 0 y 24 ciclos",
    "undo": "Deshacer",
    "undoRestored": "Alerta de snipe restaurada",
    "undoFailed": "No se pudo restaurar la alerta de snipe",
    "priceUpdated": "Precio actualizado",
    "priceUpdateFailed": "No se pudo actualizar el precio"
  },
  "personalConfig": {
    "saveSuccess": "¡Filtros predeterminados guardados correctamente!",
    "saveFailed": "No se pudieron guardar los filtros predeterminados"
  },
  "auth": {
    "registrationSuccessEmail": "¡Registro exitoso! Por favor, comprueba tu correo electrónico para la verificación.",
    "registrationSuccessLogin": "¡Registro exitoso! Por favor, inicia sesión con tu nueva cuenta.",
    "passwordResetSuccess": "Contraseña restablecida correctamente"
  },
  "common": {
    "networkError": "Error de red. Por favor, inténtalo de nuevo."
  },
  "validation": {
    "passwordRequired": "La contraseña es obligatoria",
    "passwordMinLength": "La contraseña debe tener al menos {{count}} caracteres",
    "passwordUppercase": "La contraseña debe contener al menos una letra mayúscula",
    "passwordLowercase": "La contraseña debe contener al menos una letra minúscula",
    "passwordNumber": "La contraseña debe contener al menos un número",
    "passwordSpecialChar": "La contraseña debe contener al menos un carácter especial",
    "confirmPasswordRequired": "Por favor, confirma tu contraseña",
    "passwordsDoNotMatch": "Las contraseñas no coinciden",
    "emailRequired": "El correo electrónico es obligatorio",
    "emailInvalid": "Por favor, introduce una dirección de correo electrónico válida"
  },
  "filterPreset": {
    "fetchFailed": "No se pudieron cargar los preajustes de filtro",
    "createFailed": "No se pudo crear el preajuste de filtro",
    "updateFailed": "No se pudo actualizar el preajuste de filtro",
    "deleteFailed": "No se pudo eliminar el preajuste de filtro",
    "invalidImportNotObject": "Cadena de importación no válida: no es un objeto de preajuste válido",
    "invalidImportMissingVersion": "Cadena de importación no válida: falta información de versión",
    "invalidImportMissingPreset": "Cadena de importación no válida: faltan datos del preajuste",
    "invalidPresetMissingName": "Preajuste no válido: nombre faltante o no válido",
    "invalidPresetMissingFilters": "Preajuste no válido \"{{name}}\": filtros faltantes o no válidos"
  }
}
